import { Reveal } from "./Reveal";

const PARAGRAPHS = [
  "IC Identity är ett oberoende svenskt specialistbolag inom Identity & Access Management.",
  "Erfarenheten kommer från IAM, IT-säkerhet och komplexa digitaliseringsprojekt – nära både verksamhet och IT.",
  "Vi hjälper organisationer att göra komplex identitetshantering säker, begriplig och värdeskapande.",
];

export const About = () => (
  <section id="om" className="scroll-mt-24 bg-white">
    <div className="mx-auto max-w-6xl px-6 py-24 md:py-32 lg:px-8">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-10">
        <div className="md:col-span-5">
          <Reveal>
            <p className="eyebrow">
              <span className="ic-triangle" aria-hidden="true" />
              Om IC Identity
            </p>
            <h2 className="mt-7 font-display text-3xl font-normal leading-[1.1] tracking-[-0.01em] text-brand-ink md:text-5xl">
              Vi kan identitet. På riktigt.
            </h2>
            <blockquote className="mt-10 border-l-2 border-brand-blue pl-5">
              <p className="font-display text-xl leading-snug text-brand-ink md:text-2xl">
                Nytt bolag. Decennier av erfarenhet.
              </p>
            </blockquote>
          </Reveal>
        </div>
        <div className="md:col-span-6 md:col-start-7">
          <div className="space-y-6">
            {PARAGRAPHS.map((para, i) => (
              <Reveal key={i} delay={0.06 + i * 0.05}>
                <p className="text-lg leading-relaxed text-brand-muted">{para}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
